import { SELECT_ATTRIBUTE } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'

export default {
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSelected () {
      // TODO: remove hook to store
      return this.$store.getters.hasOwnProperty('isAttributeSelected') ? this.$store.getters.isAttributeSelected(this.attribute) : false
    }
  },
  methods: {
    select (attribute) {
      this.$store.dispatch(SELECT_ATTRIBUTE, attribute)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/targetDefinition/targetDefinitionStatement/SelectableMixin.js